export default {
    "name": "SessionUserAccount",
    "kind": "HoudiniFragment",
    "hash": "78694ca78f3fee7afa1a20774edd0d370cc91eb725e5dbc3441d268cc75da69a",

    "raw": `fragment SessionUserAccount on UserAccount {
  id
  username: name
  email: workEmail
  wageRateId
  deliveryZoneId
  glDepartmentId
  driver
  salesPerson
  worker
  firstName
  lastName
  recoveryEmail
  groups {
    id
    name
  }
  stores
  highestAccessPermissions {
    id
    codeName
    category
    description
    level
  }
  settings {
    preferences {
      optInToTestingFeatures
    }
  }
  authorizedStores {
    id
    name
    code
  }
  __typename
}
`,

    "rootType": "UserAccount",
    "stripVariables": [],

    "selection": {
        "fields": {
            "id": {
                "type": "Int",
                "keyRaw": "id",
                "visible": true
            },

            "username": {
                "type": "String",
                "keyRaw": "username",
                "visible": true
            },

            "email": {
                "type": "String",
                "keyRaw": "email",
                "visible": true
            },

            "wageRateId": {
                "type": "UInt",
                "keyRaw": "wageRateId",
                "nullable": true,
                "visible": true
            },

            "deliveryZoneId": {
                "type": "UInt",
                "keyRaw": "deliveryZoneId",
                "nullable": true,
                "visible": true
            },

            "glDepartmentId": {
                "type": "UInt",
                "keyRaw": "glDepartmentId",
                "nullable": true,
                "visible": true
            },

            "driver": {
                "type": "Boolean",
                "keyRaw": "driver",
                "visible": true
            },

            "salesPerson": {
                "type": "Boolean",
                "keyRaw": "salesPerson",
                "visible": true
            },

            "worker": {
                "type": "Boolean",
                "keyRaw": "worker",
                "visible": true
            },

            "firstName": {
                "type": "String",
                "keyRaw": "firstName",
                "nullable": true,
                "visible": true
            },

            "lastName": {
                "type": "String",
                "keyRaw": "lastName",
                "nullable": true,
                "visible": true
            },

            "recoveryEmail": {
                "type": "String",
                "keyRaw": "recoveryEmail",
                "nullable": true,
                "visible": true
            },

            "groups": {
                "type": "Group",
                "keyRaw": "groups",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "stores": {
                "type": "UInt",
                "keyRaw": "stores",
                "visible": true
            },

            "highestAccessPermissions": {
                "type": "UserAccountPermission",
                "keyRaw": "highestAccessPermissions",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "codeName": {
                            "type": "String",
                            "keyRaw": "codeName",
                            "visible": true
                        },

                        "category": {
                            "type": "String",
                            "keyRaw": "category",
                            "visible": true
                        },

                        "description": {
                            "type": "String",
                            "keyRaw": "description",
                            "visible": true
                        },

                        "level": {
                            "type": "PermissionLevel",
                            "keyRaw": "level",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "settings": {
                "type": "UserSettings",
                "keyRaw": "settings",

                "selection": {
                    "fields": {
                        "preferences": {
                            "type": "UserSettingsPreferencesCategory",
                            "keyRaw": "preferences",

                            "selection": {
                                "fields": {
                                    "optInToTestingFeatures": {
                                        "type": "Boolean",
                                        "keyRaw": "optInToTestingFeatures",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "authorizedStores": {
                "type": "Store",
                "keyRaw": "authorizedStores",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "code": {
                            "type": "String",
                            "keyRaw": "code",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "__typename": {
                "type": "String",
                "keyRaw": "__typename",
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    }
};

"HoudiniHash=4907637a274f9d06e32dbb329743514c04ab340ba2ebfda45d25a0df90cd454c";